<template>
  <v-page page="Posting History" parentPage="Receivables" :breadcrumb="breadcrumb">
    <v-container ma-0 px-3 pt-0 pb-0>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <!-- HEADER -->
                <v-layout justify-start row align-center mt-3 mb-3 style="min-height: 46px;">
                  <v-flex align-center>
                    <div
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >Posting History</div>
                    <!-- <div
                      v-show="showResetBtn && !loading"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >
                      Charges for Account # {{ BAN }}
                    </div>-->
                  </v-flex>
                  <v-flex align-center xs8>
                    <v-layout row>
                      <v-flex xs2>
                        <v-autocomplete
                          class="pt-0 mr-3 mt-0"
                          hide-details
                          :items="ddlType"
                          v-model="filters.TypeId"
                          item-text="Text"
                          item-value="Value"
                          label="Type"
                          clearable
                          @change="filterBatches"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs2>
                        <v-menu
                          v-model="createdDate"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            class="mt-0 pt-0 mr-3 align-center"
                            slot="activator"
                            v-model="filters.DateForFilter"
                            label="Date"
                            prepend-inner-icon="fa-calendar-alt"
                            readonly
                            clearable
                            @input="filterBatches"
                            single-line
                            hide-details
                          ></v-text-field>
                          <v-date-picker
                            v-model="filters.DateForFilter"
                            @input="createdDate = false"
                            @change="filterBatches"
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs3 ml-5>
                        <v-layout row>
                        <v-text-field
                          v-model="search"
                          label="Search"
                          single-line
                          hide-details
                          class="align-center mt-0 pt-0"
                          @keyup.enter="filterBatches"
                        ></v-text-field>
                        <v-btn @click="filterBatches" icon mx-2 class="TierButton my-0 py-0">
                    <v-icon style="font-size:18px">fa-search</v-icon>
                  </v-btn>
                  </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout class="buttons" justify-end row align-center>
                      <!-- <v-btn class="TierButton mb-1 mr-2 ml-1" @click="exportToExcel">
                        <v-icon>fa-file-excel</v-icon> &nbsp; Excel
                      </v-btn>-->
                      <!-- <a
                          style="text-decoration: none"
                          class="align-center mr-4"
                          @click="exportToExcel"
                          >TO EXCEL</a
                      >-->
                      <!-- <v-btn
                        class="TierButton mb-1 mr-0 ml-1"
                        @click="openCreateBatch"
                      >+ New AR Batch</v-btn> -->
                      <!-- <createCharge ref="createCharge"></createCharge>
                      <editCharge ref="editCharge"></editCharge>-->
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- END HEADER -->
                <!-- Charges Table -->
                <v-data-table
                  :headers="headers"
                  :items="batches"
                  :item-key="batches.index"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :loading="loading"
                  :total-items="totalRecords"
                  @update:pagination="paginationUpdated"
                  hide-details
                  class="striped-table no-pagination-btn"
                >
                  <template slot="items" slot-scope="props">
                    <tr
                      :key="props.index"
                      :active="props.selected"
                      :style="{
                        backgroundColor: (props.item.BatchId == selectedRow ? '#C6EFCE' : '' ), 
                        color: (props.item.BatchId == selectedRow ? '#00612e' : 'black' ),
                      }"
                    >
                      <td class="text-xs-left px-0">
                        <a
                          class="mr-3"
                          style="text-decoration: none"
                          @click="openViewBatch(props.item)"
                        ><text-highlight :queries="searchHighlight">{{ props.item["BatchId"] }}</text-highlight></a>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight :queries="searchHighlight">{{
                        props.item["Type"]}}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0"><text-highlight :queries="searchHighlight">{{ formatDate(props.item["Created"]) }}</text-highlight></td>
                      <td class="text-xs-left px-0"><text-highlight :queries="searchHighlight">{{ props.item["Username"] }}</text-highlight></td>
                      <td class="text-xs-left px-0"><text-highlight :queries="searchHighlight">{{ props.item["Records"] }}</text-highlight></td>
                      <td
                        :class="{'justify-end text-xs-right pr-2 pt-0 pb-0': props.item.TotalAmount >= 0, 'justify-end text-xs-right pr-2 pt-0 pb-0 red--text': props.item.TotalAmount < 0}"
                      ><text-highlight :queries="searchHighlight">{{ formatCurrency(props.item["TotalAmount"]) }}</text-highlight></td>
                      <td class="text-xs-right px-0" ><a
                          class="mr-2"
                          style="text-decoration: none"
                          @click="openViewBatch(props.item)"
                        >VIEW</a>
                      </td>
                    </tr>
                  </template>
                  <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
                </v-data-table>
                <!-- END ACTIVE BATCHES Table-->

                <v-btn
                  color="primary"
                  @click="resetBatchList"
                  v-show="showResetBtn && !loading"
                  style="margin-top: -40px;"
                >Reset</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <viewBatch @parentInitSelectedRow="initializeSelectedRow" ref="viewBatch" id="viewBatch" @parentScroll="$vuetify.goTo('#viewBatch')"></viewBatch>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import * as helper from "../../helpers/global.js";
import moment from "moment";
import viewBatch from "./ViewBatch.vue";
import Bus from "../../bus";
  import TextHighlight from 'vue-text-highlight';
  import "@/assets/css/main.css"
  import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "HistoricalBatches",

  components: {
    VPage,
    viewBatch,
      'text-highlight':TextHighlight,
      DataTablePagination
  },

  data: () => ({
    BAN: "",
    showResetBtn: false,
    dialog: false,
    search: "",
    loading: true,
    filtersChanged: false,
    totalRecords: 0,

    selectedRow: null,
    
    filters: {},

    ddlType: [],
    batches: [],
    createdDate: false,
    searchHighlight:"",

    breadcrumb: [
      {
        text: "Receivables",
        disabled: false,
        href: "#/receivables/all"
      },
      {
        text: "Posting History",
        disabled: true,
        href: "#/receivables/all"
      }
    ],

    pagination: {
      page: 1,
      rowsPerPage: 25,
      descending: true,
      sortBy: "BatchId"
    },

    loading: false,

    rowsPerPageItems: [25, 35, 45],

    headers: [
      {
        text: "Batch ID",
        value: "BatchId",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Type",
        value: "Type",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Created",
        value: "Created",
        width: "10%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Username",
        value: "Username",
        width: "10%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Records",
        value: "Records",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Total Amount",
        value: "TotalAmount",
        width: "10%",
        fixed: true,
        align: "right",
        class: "pl-0 pr-2 font-weight-bold subheading"
      },

      {
        text: "Action",
        width: "20%",
        sortable: false,
        fixed: true,
        align: "right",
        class: "pl-0 pr-0 font-weight-bold subheading"
      }
    ]
  }),
  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },
  methods: {
    async initialize() {
      this.loading = true;
      this.filters = {};
      this.filtersChanged = true;
      this.showResetBtn = false;

     
      if (this.$route.query.search != null){
        this.search = this.$route.query.search;
        this.searchHighlight = this.$route.query.search;
    }

      this.getDropDownLists();
      this.paginationUpdated();

      this.loading = false;
    },
    getDropDownLists() {
      axios.get("/api/Receivables/GetCreateNewBatchDDL/").then(res => {
        this.ddlType = res.data.ddlBatchType;
      });
    },

    formatCurrency(value) {
      var absValue = Math.abs(value);
      var returnString = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(absValue);

      return value < 0 ? "(" + returnString + ")" : returnString;
    },
    formatDate(value) {
      if (value) return moment(value).format("YYYY-MM-DD");
      else return "";
    },
    async filterBatches() {
      this.filtersChanged = true;
      this.showResetBtn = true;
      this.searchHighlight = this.search
      this.updateSearchQuery()
      await this.paginationUpdated();
    },
    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/Receivables/GetPagedHistoryARBatchList/",
          {
            postData: {
              pagination: this.pagination,
              filtersChanged: this.filtersChanged,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.batches = response.data.batches;
          this.totalRecords = response.data.totalRecords;
        });
      this.loading = false;
      this.filtersChanged = false;
    },
    // Get list of dropdown options
    getDropdownOptions(url, obj) {
      axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },
    async resetBatchList() {
      this.loading = true;
      this.$router.push("/posting-history");
      this.pagination.totalRecords = 0;
      this.filters = {};
      this.searchHighlight=""
        this.search=""

      await this.paginationUpdated();

      this.showResetBtn = false;
      this.loading = false;
    },
    async openViewBatch(item) {
      let index = this.batches.indexOf(item);
      if (index > -1) {
        this.selectedRow = this.batches[index].BatchId;
      }
      // var isViewBatchOpen = this.$refs.viewBatch.isOpen();
      // if (isViewBatchOpen==true){
      //   await this.$refs.viewBatch.cancel();
      // }
      // await this.$refs.viewBatch.initialize()
      var viewBatch = await this.$refs.viewBatch.open({
        batchId: item.BatchId,
        type: item.Type,
        typeId: item.TypeId
      });
    },
    initializeSelectedRow(){
      this.selectedRow=null;
    },
     updateSearchQuery(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query
      var oldQuery = Object.assign({}, query)
      oldQuery.search=this.search
      this.$router.push({path:path, query:oldQuery})
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>
